import React, { useState, useEffect, useContext, useMemo } from "react";
import axios from "axios";
import '../../Style/EditModal.scss';
import "../../Style/TableStyle.scss"
import '../../Style/__searchbar.scss'
import '../../Style/__button.scss'
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import { SiHyperledger } from "react-icons/si";
import "jspdf-autotable";
import { MonthlyRentReportHeader } from "./GridHeaders/MonthlyRentReportHeader";
import DataGridComponent from "../../Components/DataGridComponent";
import { errorAlert } from "../../Components/Alerts";
import { FiscalYearContext } from "../../FiscalYear/FiscalYearContext";
import { ElementsParagraph, TitleElements } from "../../Components/HeadersCRUD-s";
import ExcelFormat from "../../Components/ExcelConverter/ExcelFormat";
import { rentColumns, rentMappings } from "../../Components/ExcelConverter/FinancialStatement";
import TotalSummaryComponent from "../../Components/TotalSummaryComponent";


export default function MonthlyRentReport() {
    const [data, setData] = useState([]);
    const headers = authHeader();
    const { fiscalYear } = useContext(FiscalYearContext);

    const fetchData = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'FinanceStatement/MonthlyRentReport', { headers, params: { fiscalYear: fiscalYear } });
            setData(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message} `);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const netoQera = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.QirajaNeto), 0);
    }, [data]);

    const tatimiQera = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.TatimiNeQira), 0);
    }, [data]);

    const totali = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.Gjithsej), 0);
    }, [data]);

    const rows = data.map((item, index) => ({
        id: ++index,
        muaji: item.Muaji,
        trs: (item.Transaksione),
        neto: (item.QirajaNeto),
        tax: (item.TatimiNeQira),
        bruto: (item.Gjithsej),
    }));


    useEffect(() => {
        fetchData();
    }, [fiscalYear]);

    return (
        <div className="Crud__Container">
            <TitleElements
                icon={SiHyperledger}
                title="Raporti mujor i qerasë"
            />
            <ElementsParagraph text="Raporti mujor i qirasë është raport sintetik që bën grumbullimin e qirasë në secilin muaj të vitit fiskal." />
            <hr></hr>

            <ExcelFormat
                data={data}
                fileName={`Raporti mujor i qirasë`}
                columns={rentColumns}
                columnMappings={rentMappings}
                buttonText="XLSX"
            />

            <DataGridComponent columns={MonthlyRentReportHeader} rows={rows} />
            <TotalSummaryComponent
                fields={[
                    { id: 1, label: 'Qiraja Neto', value: netoQera },
                    { id: 2, label: 'Tatimi ne Qira', value: tatimiQera },
                    { id: 3, label: 'Qiraja Bruto', value: totali },
                ]}
            />
        </div>
    )
}